<template>
    <div class="market">
        <strong><a :href="marketData.more_reduce_price_link" target="_blank" @click="countAd(4204)">{{marketData.cityName}}市<em>{{marketData.name}}</em>的降价行情</a></strong>
        <div class="jjhq mb10" v-for="(item,index) in marketData.list.filter((v, i) => {return i < 2;})" :key="index">
                <p class="row1">
                    <span class="col1"><a :href="item.link" target="_blank"  @click="countAd(4205)">{{item.modelName}}</a></span>
                    <span class="col2"><a :href="item.link" target="_blank"  @click="countAd(4207)">{{item.discountPrice}}万</a></span>
                    <span class="col3"><a :href="item.link" target="_blank"  @click="countAd(4208)">降{{item.maxDiscount/10000}}万</a></span>
                </p>
                <p class="row2">
                    <span class="col1">
                        <span>{{item.dealerAq === 1 ? '[4S店]' : '[展厅店]'}}</span>
                        <a :href="item.delearLink" target="_blank" :title="item.dealerName"  @click="countAd(4206)">{{item.dealerName}}</a>
                    </span>
                    <span class="col2">
                        {{item.dealer400Phone}}
                        <i class="yes" v-if="item.isShowRZicon"></i>
                        <i class="h24" v-if="item.is24Service"></i>
                        <i class="all" v-if="item.saleArea!='自定义'">{{item.saleArea}}</i> 
                    </span>
                    <span class="col3">{{item.price}}万</span>
                    <span class="col4" v-if="item.decline==0">暂无优惠</span>
                    <span class="col4" v-else>{{item.decline}}%</span>
                </p>
            </div>
            <a :href="marketData.more_reduce_price_link" target="_blank" class="moreLink"  @click="countAd(4209)">更多降价行情 &gt;&gt;</a>
        </div>
</template>

<script>
    export default {
        name: 'Market',
        props: {
            marketData: {
                type: Object,
                default: () => ({})
            }
        },
        filters:{
            salesRang(flag) { //售范围
               return flag === 0 ? '售本市' : flag === 1 ? '售本省' : flag === 2 ? '售全国' : ''
            }
        },
    }
</script>

<style lang="scss" scoped>
.market {
    margin-top: 25px;
    font-size: 12px;
    margin-bottom: 25px;
    strong {
        font-weight: normal;
        font-size: 16px;
        line-height: 32px;
        a {
            text-decoration: underline;
            color: #225599;
            em {
                color: #cc0000;
                font-style: normal;
                text-decoration: underline;
            }
        }
    }
    .jjhq {
        position: relative;
        border-bottom: 1px dashed #e2e2e2;
        a {
            color: #225599;
        }
        .row1 {
            font-weight: bold;
            line-height: 14px;
            height: 14px;
            overflow: hidden;
            span {
                height: 14px;
                line-height: 14px;
                overflow: hidden;
                float: left;
                display: inline;
            }
            .col1 {
                width: 404px;
            }
            .col2 {
                width: 59px;
                a {
                    color: #cc0000;
                }
            }
            .col3 {
                width: 60px;
                text-align: right;
                a {
                    color: #339900;
                }
            }
        }
        .row2 {
            line-height: 40px;
            height: 40px;
            overflow: hidden;
            span {
                height: 40px;
                line-height: 40px;
                overflow: hidden;
                float: left;
                position: relative;
                display: inline;
                color: #333333;
            }
            .col1 {
                width: 155px;
            }
            .col2 {
                width: 250px;
                color: #cc0000;
                font-weight: bold;
            }
            .col3 {
                width: 59px;
                text-decoration: line-through;
                color: #777777;
            }
            .col4 {
                width: 60px;
                text-align: right;
                color: #777777;
            }
        }
        .yes {
            display: inline-block;
            width: 12px;
            height: 12px;
            margin-left: 4px;
            position: relative;
            top: 2px;
            *top: -2px;
            background-position: 0 -49px;
            overflow: hidden;
            background-image: url($imageURL);
        }
        .h24 {
            display: inline-block;
            width: 22px;
            height: 12px;
            margin-left: 4px;
            position: relative;
            top: 2px;
            *top: -2px;
            background-position: 0 -37px;
            overflow: hidden;
            background-image: url($imageURL);
        }
        .all {
            color: #ffffff;
            font-style: normal;
            border-radius: 4px;
            margin-left: 10px;
            background-color: #aaaaaa;
            font-size: 12px;
            font-weight: 200;
        }
    }
    .mb10 {
        margin-bottom: 10px;
    }
    .moreLink {
        color: #225599;
        margin-top: 10px;
        display: inline-block;
        text-decoration: underline;
    }
}
</style>